/**
 *  A collection of global functions and variables
 *  that can be used throughout the application.
 *
 *  @version 0.2.0
 */

const mobileMaxWidth = 767;
const html = document.documentElement;
const body = document.body;

/**
 * Check if the current device is a mobile device
 * @type {boolean}
 */
window.isMobile = window.innerWidth <= mobileMaxWidth;
window.addEventListener('resize', () => {
    window.isMobile = window.innerWidth <= mobileMaxWidth;
});


/**
 * DOM helpers
 */
export const select = (sel, ctx = document) => ctx.querySelector(sel);
export const selectAll = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

/**
 * Get the width of the right edge of a container, taking into account the viewport width.
 * @param el
 * @returns {number}
 */
export const getRightGutter = (el) => {
    const container = el.closest('.container');
    if (!container) return 0;
    const viewportWidth = Math.round(
        (window.visualViewport && window.visualViewport.width) ||
        document.documentElement.clientWidth ||
        window.innerWidth || 0
    );
    const right = Math.ceil(container.getBoundingClientRect().right);
    return Math.max(0, viewportWidth - right);
};

export const debounce = (fn, wait = 120) => {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(null, args), wait);
    };
};


export const showModal = function(modal_id)
{
    const modal = document.querySelector("#modals_container .modal[data-modal-id=\""+modal_id+"\"");
    if (modal)
    {
        modal.classList.add("visible");
        modal.dispatchEvent(new Event('modal_show', { bubbles: true }));
        const focusField = modal.querySelector("[data-focus-on-show-modal]");
        if (focusField)
        {
            focusField.focus();
        }
    }
}

export const hideModal = function(modal_id = null)
{
    let modals, modal_to_close;
    if (modal_id!==null)
    {
        modal_to_close = document.querySelectorAll("#modals_container .modal[data-modal-id=\""+modal_id+"\"");
    }
    else
    {
        modals = document.querySelectorAll("#modals_container .modal");

        for (let modal of modals)
        {
            const rect = modal.getBoundingClientRect();

            // Check the center point of the modal
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;

            const topElement = document.elementFromPoint(centerX, centerY);

            // Check if the modal is the topmost at its own center
            if (modal.contains(topElement) || modal === topElement)
            {
                modal_to_close = modal;
            }
        }
    }
    modal_to_close.classList.remove("visible");
    modal_to_close.dispatchEvent(new Event('modal_hide' , { bubbles: true }));
}

export const  modal = function(content,title = null, rich = false)
{
    const dynamic_modal = document.querySelector("#modals_container .modal[data-modal-id=\"dynamic\"]");
    if (!rich)
    {
        content = "<p>"+content+"</p>";
    }
    if (title==null)
    {
        title = "Message";
    }
    dynamic_modal.querySelector(".modal_header > h4 > span").innerHTML = title;
    dynamic_modal.querySelector(".modal_content").innerHTML = content;
    window.showModal('dynamic');
}

export const richModal = function(content,title = null)
{
    window.modal(content,title,true);
}
